import { Controller } from "stimulus"

export default class extends Controller {
  onClick() {
    if (typeof gtag === "function" && this.event) gtag('event', this.event)
  }

  get event() {
    return this.data.get('event')
  }
}
